module.exports = __webpack_public_path__ + "fonts/Formular-Light.91907b5.woff2";